import React from 'react';
import PropTypes from 'prop-types';

import {
	MTableRow,
	MTableHeader,
	MLoader,
} from '../molecules';

export default class OCmsTable extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
		};
	}

	render() {
		let content = <MLoader className="article--loader-table" />;

		if (!this.props.isFetching && !this.props.items.length) {
			content = (
				<div className="o-cms-table--body-not-found">
					<p className="not-found">Geen data gevonden</p>
				</div>
			);
		} else if (!this.state.isFetching) {
			content = this.props.items.map(item => (
				<MTableRow
					id={item.uuid}
					key={item.uuid}
					value={item.name || item.username}
					onEdit={this.props.onEdit}
					onDelete={this.props.onDelete}
					noEdit={this.props.noEdit}
					noDelete={this.props.noDelete}
				/>
			));
		}


		return (
			<section className="o-cms-table">
				<MTableHeader
					columns={this.props.columns}
					onSearch={this.props.onSearch}
				/>

				<div className="o-cms-table--body">
					{content}
				</div>
			</section>
		);
	}
}

OCmsTable.propTypes = {
	columns: PropTypes.array,
	items: PropTypes.array,
	isFetching: PropTypes.bool,
	onSearch: PropTypes.func,
	onEdit: PropTypes.func,
	onDelete: PropTypes.func,
	noEdit: PropTypes.bool,
	noDelete: PropTypes.bool,
};

OCmsTable.defaultProps = {
	columns: [],
	items: [],
	isFetching: true,
	onSearch: undefined,
	onEdit: undefined,
	onDelete: undefined,
	noEdit: false,
	noDelete: false,
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.cms-table.js